export enum SoundFileName {
    MoneyPrize = 'money-prize.mp3',
    MessageNotification = 'message-notification.mp3',
}
